// Messages courts FR / EN / ES pour les erreurs autrefois avalees (console.log seul)
// et pour la session expiree (relecture v5, A4). Langue inconnue : anglais.
const M = {
  fr: {
    sessionExpiree: "Votre session a expiré ou a été ouverte sur un autre appareil (ordinateur, téléphone). Reconnectez-vous.",
    mailOk: "Courriel envoyé. Pensez à regarder dans vos indésirables.",
    mailKo: "L'envoi du fichier par e-mail n'a pas abouti. Réessayez plus tard ou contactez le SAV.",
    suppressionKo: "La suppression n'a pas abouti. Réessayez ou contactez le SAV.",
    modificationKo: "La modification n'a pas été enregistrée. Réessayez.",
  },
  en: {
    sessionExpiree: "Your session has expired or was opened on another device (computer, phone). Please sign in again.",
    mailOk: "Email sent. Please check your spam folder too.",
    mailKo: "The file could not be sent by email. Please try again later or contact after-sales support.",
    suppressionKo: "The removal failed. Please try again or contact after-sales support.",
    modificationKo: "The change was not saved. Please try again.",
  },
  es: {
    sessionExpiree: "Su sesión ha caducado o se ha abierto en otro dispositivo (ordenador, teléfono). Vuelva a iniciar sesión.",
    mailOk: "Correo enviado. Revise también la carpeta de correo no deseado.",
    mailKo: "No se pudo enviar el archivo por correo. Inténtelo más tarde o contacte con el servicio posventa.",
    suppressionKo: "No se pudo eliminar. Inténtelo de nuevo o contacte con el servicio posventa.",
    modificationKo: "El cambio no se ha guardado. Inténtelo de nuevo.",
  },
};
export const msg = (lang, cle) => ((M[lang] || M.en)[cle]);
export const langueCourante = () => {
  const m = (window.location.pathname || "").match(/^\/(fr|en|es)(\/|$)/);
  return m ? m[1] : "fr";
};
